<template>
  <div class="header-wrapper" :class="{ 'not-fixed': fixedHeader }">
    <div class="header">
      <router-link tag="a" :to="{ name: 'admin' }" class="header__logo">
        <vimg src="static/images/logo.svg" />

        <span class="header__admin-label">Admin</span>
      </router-link>

      <transition name="slide-fade">
        <navigation />
      </transition>

      <profile-info />
    </div>
  </div>
</template>

<script>
// import SearchForm from './SearchForm';
import Navigation from './Navigation';
import ProfileInfo from './ProfileInfo';

export default {
  name: 'VcvHeaderAdmin',

  components: {
    // SearchForm,
    Navigation,
    ProfileInfo
  },

  // props: {
  //   displayNavigation: {
  //     type: Boolean,
  //     default: false
  //   }
  // },

  // data() {
  //   return {
  //     isSecondNavVisible: true
  //   };
  // },

  computed: {
    headerStyle() {
      return this.$route.meta ? this.$route.meta.headerOptions : null;
    },

    fixedHeader() {
      return this.headerStyle ? this.headerStyle.fixed === false : null;
    }
  }

  // watch: {
  //   '$route' (to, from) {
  //     this.handleScroll();
  //   }
  // },

  // created() {
  //   window.addEventListener('scroll', this.handleScroll);
  // },
  //
  // destroyed() {
  //   window.removeEventListener('scroll', this.handleScroll);
  // },

  // methods: {
  //   isInViewport(element) {
  //     const rect = element.getBoundingClientRect();
  //     const html = document.documentElement;
  //     return (
  //       rect.top >= 0 &&
  //       rect.left >= 0 &&
  //       rect.bottom <= (window.innerHeight || html.clientHeight) &&
  //       rect.right <= (window.innerWidth || html.clientWidth)
  //     );
  //   },
  //
  //   handleScroll() {
  //     const secondNav = document.getElementsByClassName('second-nav')[0];
  //     if (secondNav) {
  //       this.isSecondNavVisible = this.isInViewport(secondNav);
  //     }
  //   }
  // }
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/queries.scss';

// .admin-label-wrapper {
//   display: inline-block;
// }
//
// // .logo-img {
// //   // width: 79px;
// // }
//
// .admin-label {
//   font-size: 10px;
//   padding: 3px 4px;
//   background: #db371d;
//   color: #fff;
//   border-radius: 6px;
//   margin: 0 5px;
//   position: relative;
//   bottom: -1px;
//   text-transform: uppercase;
//   display: inline-block;
//   left: -11px;
// }
//
// .header-wrapper {
//   position: fixed;
//   top: 0;
//   left: 0;
//   z-index: 200;
//   width: 100%;
//   background: #fff;
//   border-bottom: 1px solid $input-light-border-color;
//
//   &.not-fixed {
//     position: relative;
//   }
// }
//
// .header {
//   width: 100%;
//   height: 50px;
//   margin: 0 auto;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//
//   // @include widescreen {
//   //   max-width: 1200px;
//   // }
//
//   @include desktop {
//     max-width: 970px;
//   }
//
//   @include tablet {
//     max-width: 750px;
//   }
//
//   .logo {
//     margin-left: 0;
//   }
//
//   .search-block {
//     margin-left: 30px;
//     margin-right: 20px;
//   }
//
//   .slide-fade-enter,
//   .slide-fade-leave-to {
//     transition: all 0.2s ease;
//     transform: translateX(5px);
//     opacity: 0;
//   }
// }
//
// .is_admin {
//   .header {
//     padding: 0 15px;
//
//     @include widescreen {
//       max-width: 100%;
//     }
//
//     @include desktop {
//       max-width: 100%;
//     }
//
//     @include tablet {
//       max-width: 100%;
//     }
//   }
// }
</style>
